import { BrowserRouter, Routes, Route } from "react-router-dom";
import { BusinessBlockList } from "./components/BusinessBlockList";
import { ChooseYourPlan } from "./components/ChooseYourPlan";
import { Home } from "./components/Home";
import { Login } from "./components/Login";
import { NewCNPJBlocking } from "./components/NewCNPJBlocking";
import { Profile } from "./components/Profile";
import { SettingsProfile } from "./components/SettingsProfile";
import { NewSearch } from "./components/newSearch";
import { Results } from "./components/Results";
import { SearchHistory } from "./components/SearchHistory";
import { Users } from "./components/Users";
import { PrivateRouter } from "./components/PrivateRoute";
import { AdminRouter } from "./components/AdminRouter";
import { SearchManager } from "./components/Admin/SearchManager";
import ResetPassword from "./components/Login/resetPassword";
import { ParametrosBrf } from "./components/BRF";
import { AnaliseBRT } from "./components/AnaliseBRT";
import { PrivacyPolicy } from "./components/Policies/privacidade";
import { AppVisualization } from "./components/Visualization";
import { AppPreview } from "./components/Preview";
import { Wallet } from "./components/Wallet";
import { Account } from "./components/Account";
import { Purchase } from "./components/Purchase";
import { SSO } from "./components/Login/sso";
import { BlockUser } from "./components/BlockUser";
import { ResumoPorPorte } from "./components/ResumoPorPorte";
import { CustomerTable } from "./components/CustomerTable";
import { BatchAnalysis } from "./components/BatchAnalysis";
import { UserScreen } from "./components/UserScreen";
import { OrderDetails } from "./components/OrderDetails";
import { NoTouchRouter } from "./components/NoTouchRouter";
import { ImportPlanilha } from "./components/ImportPlanilha";
import { HistoryImport } from "./components/HistoryImportPlanilha";
import { NovaAnalise } from "./components/newSearchPetro";
import { SumulaPetrobahia } from "./components/SumulaPetrobahia";
import { SumulaList } from "./components/ListaSumulasPetroBahia";
import { DeclaracaoFaturamento } from "./components/DadosBasicoClientePetro";
import { Unit } from "./components/Unit";
import { ConfiguracoesForm } from "./components/Params/configuration";
import { InstrucoesParametrizacao } from "./components/Params/help";
import { MonitoramentoLayout } from "./components/MonitoramentoSerasa/MonitoramentoLayout";
import { MonitoramentoHome } from "./components/MonitoramentoSerasa/MonitoramentoHome";
import { MonitoramentoCarteira } from "./components/MonitoramentoSerasa/MonitoramentoCarteira";
import { MonitoramentoFornecedor } from "./components/MonitoramentoSerasa/MonitoramentoFornecedor";
import { MonitoramentoRelatorio } from "./components/MonitoramentoSerasa/MonitoramentoRelatorio";

export const RouteManagement = () => (
  <BrowserRouter>
    <Routes>
      <Route path="/" element={<Login />} />
      <Route element={<PrivateRouter />}>
        <Route path="/gerenciarpesquisa" element={<AdminRouter />}>
          <Route path="/gerenciarpesquisa" element={<SearchManager />}></Route>
        </Route>
        <Route path="/novapesquisa" element={<NewSearch />}></Route>
        <Route path="Perfil" element={<Profile />} />
        <Route path="configuracao" element={<SettingsProfile />} />
        <Route path="/analisebrt" element={<AnaliseBRT />}></Route>
        <Route path="novo-bloqueio-de-cnpj" element={<NewCNPJBlocking />} />
        <Route path="empresas-bloqueadas" element={<BusinessBlockList />} />
        <Route path="/historico" element={<SearchHistory />}></Route>
        <Route path="/usuarios" element={<Users />}></Route>
        <Route path="/resultados" element={<Results />} />
        <Route path="/resultados/:id" element={<Results />} />
        <Route path="/configuracao/Brf" element={<ParametrosBrf />}></Route>
        <Route path="/block-list" element={<BlockUser />} />
        <Route path="/resumo-porte" element={<ResumoPorPorte />} />
        <Route path="/historico-lote" element={<CustomerTable />} />
        <Route path="/analise-lote" element={<BatchAnalysis />}></Route>
        <Route path="/import-planilha" element={<ImportPlanilha />}></Route>
        <Route path="/relacionamento-cliente" element={<HistoryImport />} />
        <Route path="/unidade-empresa" element={<Unit />} />
        <Route path="/parametrizacao" element={<ConfiguracoesForm />}></Route>
        <Route
          path="/configuracoes/ajuda"
          element={<InstrucoesParametrizacao />}
        />

        <Route path="/monitoramento" element={<MonitoramentoLayout />}>
          <Route index element={<MonitoramentoHome />} />
          <Route path="carteira" element={<MonitoramentoCarteira />} />
          <Route path="fornecedor/:cnpj" element={<MonitoramentoFornecedor />} />
          <Route path="relatorio" element={<MonitoramentoRelatorio />} />
        </Route>

        <Route element={<NoTouchRouter />}>
          <Route path="/carteira" element={<Wallet />}></Route>
          <Route path="/conta" element={<Account />}></Route>
          <Route path="/compra" element={<Purchase />}></Route>
          <Route path="/detalhes" element={<OrderDetails />}></Route>
        </Route>
        <Route path="/sumula/:id" element={<SumulaPetrobahia />} />
        <Route path="/lista-sumula" element={<SumulaList />} />
        <Route path="/dados-cliente" element={<DeclaracaoFaturamento />} />
      </Route>
      <Route path="/home" element={<Home />} />
      <Route path="login" element={<Login />} />
      <Route path="sso" element={<SSO />} />
      <Route path="escolha-seu-plano" element={<ChooseYourPlan />} />
      <Route path="/*" element={<Home />} />
      <Route path="/reset-password/:code" element={<ResetPassword />} />
      <Route path="/policy" element={<PrivacyPolicy />} />
      <Route path="/visualization/:analiseId" element={<AppVisualization />} />
      <Route path="/preview" element={<AppPreview />} />
      <Route path="/nova-analise" element={<NovaAnalise />} />
    </Routes>
  </BrowserRouter>
);
